import type { Verification } from '@/features/verifications/types/verification.types';

export const EDIT_LOCKED_REASON = 'Experience is locked after a verification request is sent';
export const DELETE_LOCKED_REASON =
  'Experience cannot be deleted after a verification request is sent';

export const isExperienceLocked = (contacts: Verification[] | null): boolean =>
  contacts?.some((contact) => contact.status !== 'DRAFT') ?? false;

export function getEditDisabledReason(
  contacts: Verification[] | null,
  isLoading: boolean
): string | undefined {
  if (contacts === null) {
    return isLoading
      ? 'Reference contacts are still loading'
      : 'Reference contacts could not be loaded';
  }
  return isExperienceLocked(contacts) ? EDIT_LOCKED_REASON : undefined;
}
